import React from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";

function enableCookies() {}

export const CookieConsentBar = () => {
  if (getCookieConsentValue() === "true") {
    enableCookies();
  }
  return (
    <CookieConsent
      location="bottom"
      buttonText="I Understand."
      onAccept={enableCookies}
      buttonStyle={{
        "backgroundColor":"#469bff",
        "fontWeight": "bold"
      }}
    >
      To provide you the best experience possible we gather anonymous 
      user data in the form of cookies; if you do not consent to this, please 
      close this webpage. Please send any questions or concerns to our privacy 
      officer at: <a href="mailto:privacy@nexushealth.ca">Privacy@nexushealth.ca</a>
    </CookieConsent>
  );
};
